const wowApp = require('angular').module('wowApp.common');

wowApp.service('PaypalService', ['Restangular', '$q', require('./paypal.service')]);



// WEBPACK FOOTER //
// ./src/common/paypal/index.js